<rt-dialog-header [heading]="title"></rt-dialog-header>

<div class="confirm-body" space-lr padding-tb-small>
  <p *ngIf="message" [innerHTML]="message"></p>

  <ng-container *ngIf="list.length">
    <ul class="list">
      <li
        *ngFor="let item of list; trackBy: trackByValue"
        [innerHTML]="item"
        class="list__item"
      ></li>
    </ul>
  </ng-container>

  <ng-container *ngIf="visibleTags.length">
    <rt-group margin-tb-small class="tags">
      <rt-tag
        *ngFor="let tag of visibleTags; trackBy: trackByValue"
        [name]="tag"
        [isClickable]="false"
        [isHoverable]="false"
      >
      </rt-tag>
    </rt-group>
    <div *ngIf="tagsCollapseActive" layout>
      <rt-button (click)="toggleTagsCollapse()" variant="plain small-x has-icon icon-right">
        <ng-container *ngIf="tagsCollapsed">
          {{ showMoreLabel }} ({{ tags.length - visibleTags.length }})
        </ng-container>
        <ng-container *ngIf="!tagsCollapsed">
          {{ showLessLabel }}
        </ng-container>
        <rt-icon size="small" [name]="tagsCollapsed ? 'expand-more' : 'expand-less'"></rt-icon>
      </rt-button>
    </div>
  </ng-container>

  <ng-content></ng-content>
  <ng-template [ngIf]="state.tmpCheckboxes.length > 0">
    <div class="form" [class.with-top-border]="message">
      <div>
        <div
          *ngFor="
            let option of state.tmpCheckboxes;
            trackBy: trackByCheckbox;
            let i = index;
            let last = last
          "
          class="choice-item"
        >
          <rt-group>
            <div class="option-container">
              <rt-checkbox
                [checked]="option.value"
                (valueChange)="handleCheckboxValueChange(i, $event)"
              >
                <rt-label [class.marked]="last && emphasizeLastCheckbox">
                  <span [innerHTML]="option.label"></span>
                </rt-label>
              </rt-checkbox>
            </div>
          </rt-group>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container *ngIf="footerMessage">
    <rt-divider margin-bottom-small></rt-divider>
    <p [innerHTML]="footerMessage"></p>
  </ng-container>
</div>

<rt-divider></rt-divider>

<div class="confirm-actions" [class.safe-footer]="safeFooter" padding-lr-medium padding-tb-small>
  <rt-group
    variant="horizontal"
    [attr.layout-justify-flex-end]="confirmActionsLayout === 'end' || null"
    [attr.layout-space-between]="confirmActionsLayout === 'space-between' || null"
  >
    <rt-button *ngIf="isCancelable" (click)="cancel()" variant="plain">
      {{ cancelLabel }}
    </rt-button>
    <rt-button
      [class.error]="variant === ConfirmDialogVariant.Error"
      [class.primary]="variant === ConfirmDialogVariant.Information"
      [class.warning]="variant === ConfirmDialogVariant.Warning"
      [disabled]="!isFormValid"
      (click)="confirm()"
    >
      {{ agreeLabel }}
    </rt-button>
  </rt-group>
</div>
